export const arrowIconSVG = (): string => {
  return `<div class="swipe-control__arrow-wrapper">
    <div class="swipe-control__arrow-rotate">
        <div class="swipe-control__arrow-inner">
            <div class="swipe-control__arrow-svg-wrapper">
                <svg class="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 19 20">
                    <g filter="url(#filter0_d_1_312)" id="keyboard_double_arrow_up">
                        <path d="M5.23181 15.4978L4 14.2966L9.27918 9.14829L14.5584 14.2966L13.3265 15.4978L9.27918 11.5723L5.23181 15.4978ZM5.23181 10.3496L4 9.14829L9.27918 4L14.5584 9.14829L13.3265 10.3496L9.27918 6.42399L5.23181 10.3496Z" fill="#FFF07E"></path>
                    </g>
                    <defs>
                        <filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="19.4978" id="filter0_d_1_312" width="18.5584" x="0" y="0">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
                            <feOffset></feOffset>
                            <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                            <feComposite in2="hardAlpha" operator="out"></feComposite>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
                            <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1_312"></feBlend>
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_1_312" mode="normal" result="shape"></feBlend>
                        </filter>
                    </defs>
                </svg>
            </div>
        </div>
    </div>
</div>`;
};
